/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Modal, Pagination, CustomLoading, Label, Input, Breadcrumb } from "../../../Components";

/* 🔗 SERVICE */
import { LogServices } from "../../../Services/logServices";

/* 🧠 REDUX */
import { store } from "../../../Redux/Store";
import { useSelector } from "react-redux/es/hooks/useSelector";
import { changeModal } from "../../../Redux/Actions";

/* 📁 ASSETS*/
import { Lupa, Visualizar, Atualizar, Email, Download, Excluir, Segurança, UpdatePassword, PlusIcon } from "../../../Assets/icons";
import { LogOutIcon, LogInIcon } from "../../../Assets/icons/MenuIcons";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, HeaderContainer, 
    InputContainer, FilterInput, ContainerHead, ContainerRow, ContainerColumn, CardsContainer, Card, CardIcon } from "./styles";

/* 🔧 UTILS */
import { isValidEndData, isValidStartData } from "../../../util/validate";

const buildStatusTypes = (t) => ({
  index: { label: t("administrative.sub-items.logs.status.index"), src: Visualizar },
  show: { label: t("administrative.sub-items.logs.status.show"), src: Visualizar },
  login: { label: t("administrative.sub-items.logs.status.login"), src: LogInIcon },
  logout: { label: t("administrative.sub-items.logs.status.logout"), src: LogOutIcon },
  excel: { label: t("administrative.sub-items.logs.status.excel"), src: Download },
  view: { label: t("administrative.sub-items.logs.status.view"), src: Visualizar },
  update: { label: t("administrative.sub-items.logs.status.update"), src: Atualizar },
  updated: { label: t("administrative.sub-items.logs.status.updated"), src: Atualizar },
  create: { label: t("administrative.sub-items.logs.status.create"), src: PlusIcon },
  created: { label: t("administrative.sub-items.logs.status.created"), src: PlusIcon },
  store: { label: t("administrative.sub-items.logs.status.store"), src: PlusIcon },
  delete: { label: t("administrative.sub-items.logs.status.delete"), src: Excluir },
  deleted: { label: t("administrative.sub-items.logs.status.deleted"), src: Excluir },
  attach: { label: t("administrative.sub-items.logs.status.attach") },
  detach: { label: t("administrative.sub-items.logs.status.detach") },
  command: { label: t("administrative.sub-items.logs.status.command") },
  "2fa": { label: t("administrative.sub-items.logs.status.2fa"), src: Segurança },
  changepassword: { label: t("administrative.sub-items.logs.status.changepassword"), src: UpdatePassword },
  confirmemail: { label: t("administrative.sub-items.logs.status.confirmemail"), src: Email },
});

const ListLogs = () => {
    const { t } = useTranslation();

    document.title = t("administrative.sub-items.logs.document-title");

    const statusTypes = buildStatusTypes(t);
    const navigationFlow =  [
        { text: 'administrative', page: '/adm/logs' },
        { text: 'logs', page: '/adm/logs' }
    ]
    const user = useSelector(state => state.userReducer);

    const Services = useRef(new LogServices());
    const searchValue = useRef();
    
    const [logs, setLogs] = useState([]);
    const [log, setLog] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingLog, setIsLoadingLog] = useState(true);
    const [datainicio, setDatainicio] = useState(new Date().toISOString(Date.now() - 3 * 60 * 60 * 1000).slice(0, 10)+'T00:00');
    const [datafim, setDatafim] = useState(new Date(Date.now() - 3 * 60 * 60 * 1000).toISOString().slice(0, 10)+'T23:59:59');

    const getLogs = async() => {
        let currentitem = await Services.current.getAllLogs();
        setLogs(currentitem);
        setIsLoading(false);
    }

    useEffect(() => {
        getLogs();
    }, []);

    const aplyFilter = async() => {
        setIsLoading(true);
        let currentitem = await Services.current.getAllLogs(searchValue.current);
        setLogs(currentitem);
        setIsLoading(false);
    }

    const changePage = async(page) => {
        setIsLoading(true);
        let currentitem = await Services.current.getAllLogs(searchValue.current, page);
        setLogs(currentitem);
        setIsLoading(false);
    }

    const getLog = async(logid) => {
        setIsLoadingLog(true);
        store.dispatch(changeModal('logItem'));
        let currentitem = await Services.current.getLog(logid);
        // console.log(currentitem);
        setLog(currentitem);
        setIsLoadingLog(false);
    }

    // Formata a data com base no idioma
    const formatDate = (value) => {
        const dateObj = new Date(value);
        return t("date.date-hour", {date: new Date(dateObj), format: "dateAndHour"});
    }

    // Pega os valores antigos e novos do log
    const getDiffValues = (diff) => {
        if (!diff) return { oldValue: "", newValue: "" };

        const oldValue = Object.values(diff.old || {}).join(", ");
        const newValue = Object.values(diff.attributes || {}).join(", ");

        return { oldValue, newValue };
    };

    return(
        <>
            <Container>
                <Breadcrumb flow={navigationFlow}/>
                <PageTitle>
                    {t("administrative.sub-items.logs.page-title")}
                </PageTitle>

                <HeaderContainer>
                    <InputContainer>
                        <img src={Lupa} alt={t("inputs.search-logs.alt")}></img>
                        <FilterInput
                            // onBlur={()=>Aplyfilter()}
                            onKeyDown={(e) => e.key === 'Enter' && aplyFilter()}
                            onChange={(e) => searchValue.current = e.target.value}
                            placeholder={t("inputs.search-logs.placeholder")}
                        />
                    </InputContainer>

                    <Button width={'fit-content'} text={t("buttons.apply")} color={'green'} onClick={() => aplyFilter()}></Button>
                </HeaderContainer>
                
                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + logs?.total + " " + t("administrative.sub-items.logs.logs") }
                    </CountContainer>
                    {user?.user?.can?.includes('log.export') ?
                        <Button onClick={() => store.dispatch(changeModal('exportParms'))} width={'fit-content'} color={'green'} text={t("buttons.export")}></Button>
                    :<></>}
                </ContainerHead>
                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.description") }</TitleText>
                        <TitleText>{t("inputs.date.label")}</TitleText>
                    </LineTitle>
                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        logs?.data?.map((item) => (
                            
                            <LineList key={item.id} onClick={() => user?.user?.can?.includes('log.view') && getLog(item.id)}>
                                <ListText>{item.description}</ListText>
                                <ListText>{formatDate(item.created_at)}</ListText>
                            </LineList>
                        ))
                    }
                </ContainerList>

                <Pagination last_page={logs?.last_page} currentpage={logs?.current_page} changepage={changePage}/>
            </Container>
            
            <Modal title={t("modal.export-parms.title")} name={'exportParms'} width={'60%'} height={'50%'}>
                <ContainerRow>
                    <ContainerColumn>
                        <Label text={t("inputs.initial-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datainicio' 
                            name='datainicio' 
                            type="datetime-local" 
                            placeholder={t("inputs.initial-date.placeholder")}
                            value={datainicio}
                            max={datafim}
                            // innerRef={UserField}
                            invalidMessage={t("inputs.initial-date.invalid-message")}
                            validationFunction={(text) => isValidStartData(text, datafim)}
                            onchange={(text) => setDatainicio(text)}> 
                        </Input>
                    </ContainerColumn>
                    <ContainerColumn>
                        <Label text={t("inputs.final-date.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='datafim' 
                            name='datafim' 
                            type="datetime-local" 
                            placeholder={t("inputs.final-date.placeholder")}
                            value={datafim}
                            min={datainicio}
                            invalidMessage={t("inputs.final-date.invalid-message")}
                            validationFunction={(text) => isValidEndData(datainicio, text)}
                            onchange={(text) => setDatafim(text)}> 
                        </Input>
                    </ContainerColumn>
                </ContainerRow>
                <Button text={t("buttons.download")} width={'150px'} onClick={() => Services.current.getExcel(datainicio, datafim)}/>
            </Modal>

            <Modal title={t("modal.logItem.title")} name={'logItem'} width={'40%'} height={'40%'}>
                {isLoadingLog ?
                    <CustomLoading width={'150px'} height={'150px'}/>
                    :
                    <CardsContainer>
                        <Card>
                            <h3 className="profile-view__title">{statusTypes[log?.event]?.label}</h3>
                            <div className="profile-view__card">
                                <div className="profile-view__header">
                                    <CardIcon src={statusTypes[log?.event]?.src} $isSpecial={log?.event === 'deleted' || log?.event === 'delete' || log?.event === '2fa'} />
                                    {!log?.differences || log?.differences === "[]" || (log?.event !== 'updated' && log?.event !== 'update') ? (
                                        <span className="profile-view__name">{t("administrative.sub-items.logs.profile") + " " + log?.causer?.name}</span>
                                    ) : (
                                        (() => {
                                            let diff;
                                            try {
                                                diff = JSON.parse(log?.differences);
                                            } catch (error) {
                                                console.error("Erro ao fazer parse de log.differences:", error);
                                                diff = {}; 
                                            }
                                            const { oldValue, newValue } = getDiffValues(diff);
                                            return (
                                                <div className="profile-view__values">
                                                    {oldValue && <span className="profile-view__old-value">{oldValue}</span>}
                                                    <span className="profile-view__new-value">{newValue}</span>
                                                </div>
                                            );
                                        })()
                                    )}
                                </div>

                                <div className="profile-view__info">
                                    <span className="profile-view__date">{formatDate(log?.created_at)}</span>
                                    <span className="profile-view__company">{log?.causer?.allocation?.name}</span>
                                </div>

                                <p className="profile-view__description">{log?.description}</p>
                            </div>
                        </Card>
                    </CardsContainer>   
                }
            </Modal>
        </>
    )
}

export default ListLogs;
